import { useTranslation } from "react-i18next";

import Fields from "./Fields";
import { FormContainer, useFetch } from "@4uhub/lib4uhub";

import {
  beneficiaryCancellationReasonSchema,
  TBeneficiaryCancellationReasonForm,
} from "./beneficiaryCancellationReason.schema";
import {
  createBeneficiaryCancellationReason,
  findBeneficiaryCancellationReasonById,
  updateBeneficiaryCancellationReason,
} from "../../../../../services/beneficiaryCancellationReason.service";
import { buildTPath } from "../beneficiaryCancellationReason.utils";

const BeneficiaryCancellationReason = () => {
  const { t } = useTranslation();

  const translate = (path: string) => t(buildTPath(path));

  const { sendRequest: create, loading: isSaving } = useFetch(
    createBeneficiaryCancellationReason
  );
  const { sendRequest: update, loading: isUpdating } = useFetch(
    updateBeneficiaryCancellationReason
  );
  const { sendRequest: findById, loading: isFetching } = useFetch(
    findBeneficiaryCancellationReasonById
  );

  const updateHandler = (
    values: TBeneficiaryCancellationReasonForm,
    id: string
  ) => update({ id, item: { ...values, id } });

  const isLoading = isSaving || isUpdating || isFetching;

  return (
    <FormContainer<TBeneficiaryCancellationReasonForm>
      saveFunction={create}
      getFunction={findById}
      updateFunction={updateHandler}
      loading={isLoading}
      title={translate("title")}
      schema={beneficiaryCancellationReasonSchema}
      subtitle={translate("new")}
      subtitleWatchField="name"
      fields={() => <Fields />}
    />
  );
};

export default BeneficiaryCancellationReason;
